import ArrayUtils from '@/utils/arrayUtils'

export default
{
    namespaced: true,
    
    state:
    {
        objectsList: [],
        tags: []
    },

    getters:
    {
        getObjectById: state => id =>
        {
            return state.objectsList.find(r => r.id == id)
        }
    },
    
    mutations:
    {
        updateObjectsList (state, objects) 
        {
            var merged = ArrayUtils.mergeArrays(state.objectsList, objects, (a, b) => a.id == b.id)

            merged = merged.sort((a, b) =>
            {
                let dDate = new Date(b.date) - new Date(a.date)
                let dId = b.id - a.id

                return dDate + dId
            })

            state.objectsList = merged
        },

        setTags (state, tags) 
        {
            state.tags = tags
        }
    },

    actions:
    {
        removeObjectById ({ getters, state }, id)
        {
            let object = getters.getObjectById(id)
            
            if (!object) return
            
            const objects = state.objectsList
            objects.splice(objects.indexOf(object), 1)

            state.objectsList = objects
        }
    }
}


// WEBPACK FOOTER //
// ./src/stores/lostObjects.js